import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initFirebase } from './firebase'
import { FirebaseAuthService } from './services/firebaseAuthService'

async function initializeApp() {
  try {
    await initFirebase()
    new FirebaseAuthService() // Initialize auth service
    const app = createApp(App)
    app.use(router)
    app.mount('#app')
  } catch (error) {
    console.error('Firebase initialization error:', error)
  }
}

initializeApp()
